var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        { attrs: { disabled: _vm.formDisabled } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                slot: "detail",
                model: _vm.model,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [_c("a-form-model-item", { attrs: { label: "基础信息" } })],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "厂区",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "factoryId"
                          }
                        },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: { placeholder: "请选择厂区" },
                              on: { change: _vm.backFactory },
                              model: {
                                value: _vm.model.factoryId,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "factoryId", $$v)
                                },
                                expression: "model.factoryId"
                              }
                            },
                            _vm._l(_vm.factoryOptions, function(d) {
                              return _c(
                                "a-select-option",
                                { key: d.id, attrs: { value: d.id } },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(d.name) +
                                      "\n              "
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "区域",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "areaId"
                          }
                        },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: { placeholder: "请选择区域" },
                              on: { change: _vm.backArea },
                              model: {
                                value: _vm.model.areaId,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "areaId", $$v)
                                },
                                expression: "model.areaId"
                              }
                            },
                            _vm._l(_vm.areaOptions, function(d) {
                              return _c(
                                "a-select-option",
                                { key: d.id, attrs: { value: d.id } },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(d.name) +
                                      "\n              "
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "楼栋编码",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "code"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入楼栋编码" },
                            model: {
                              value: _vm.model.code,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "code", $$v)
                              },
                              expression: "model.code"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "楼栋名称",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "name"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入楼栋名称" },
                            model: {
                              value: _vm.model.name,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "name", $$v)
                              },
                              expression: "model.name"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c("a-form-model-item", {
                        attrs: { label: "楼栋负责人信息" }
                      })
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "负责人姓名",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "principal"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入负责人姓名" },
                            model: {
                              value: _vm.model.principal,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "principal", $$v)
                              },
                              expression: "model.principal"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "联系电话",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "telephone"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入负责人联系电话" },
                            model: {
                              value: _vm.model.telephone,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "telephone", $$v)
                              },
                              expression: "model.telephone"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "邮箱",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "email"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入负责人邮箱" },
                            model: {
                              value: _vm.model.email,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "email", $$v)
                              },
                              expression: "model.email"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c("a-form-model-item", {
                        attrs: { label: "楼栋图片信息" }
                      })
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "" } },
                        [
                          _c("j-image-upload", {
                            staticClass: "avatar-uploader",
                            attrs: {
                              text: "上传",
                              "upload-source": _vm.uploadSource,
                              isMultiple: true,
                              disabled: _vm.disableSubmit
                            },
                            model: {
                              value: _vm.model.fileList,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "fileList", $$v)
                              },
                              expression: "model.fileList"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }